import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { decodePayload } from "../utils/decoder";
import PreuseReport from "../components/PreuseReport";

export default function ViewPage() {
  const location = useLocation();

  const [data, setData] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    try {
      const query = new URLSearchParams(location.search);
      const encoded = query.get("data");

      if (!encoded) {
        setError("No data in URL");
        setData([]);
        return;
      }

      const decoded = decodePayload(encoded);
      setError("");
      setData(decoded);
    } catch (e) {
      console.error(e);
      setError(`Failed to decode data${e?.message ? `: ${e.message}` : ""}`);
      setData([]);
    }
  }, [location.search]);

  const query = new URLSearchParams(location.search);
  const encoded = query.get("data");

  return (
    <div style={{ padding: error ? "20px" : 0, minHeight: "100vh" }}>
      {error && (
        <p style={{ color: "#ff8a80", fontFamily: "Roboto Mono, monospace", padding: 20 }}>
          {error}
        </p>
      )}

      {!error && data.length > 0 && <PreuseReport data={data} />}

      {!error && encoded && data.length === 0 && (
        <p style={{ color: "rgba(234,242,255,0.6)", padding: 20 }}>No test rows decoded.</p>
      )}
    </div>
  );
}